import { CompanyLicensingTabBaseDataProvider } from './CompanyLicensingTabBaseDataProvider';
import { CompanyData } from '../../../types/company-data';
import { User } from '../../../types/user';
import { CompanyLicenseInformation } from '../../../../license/types/CompanyLicenseInformation';

export class CompanyLicensingTabGzDataProvider extends CompanyLicensingTabBaseDataProvider {
  public async getMyCompanyData(): Promise<CompanyData> {
    const record = await this.dependencies.api.clients.MyCompany.GetRecord().toPromise();

    if (!record || !record.data) {
      throw new Error('No my company data');
    }

    return record.data;
  }

  public async getManagedCompanyById(companyId: string): Promise<CompanyData> {
    const record = await this.dependencies.api.clients.Company.GetManagedCompanyById(companyId).toPromise();

    if (!record) {
      throw new Error('No edited company data');
    }

    return record;
  }

  public async getLoggedUser(): Promise<User> {
    const user = await this.dependencies.api.clients.Users.GetLoggedUser().toPromise();

    if (!user) {
      throw new Error('No logged user data');
    }

    return user;
  }

  public async getCompanyLicenseInformation(editedCompanyId: string): Promise<CompanyLicenseInformation> {
    const companyLicenseInfo = await this.dependencies.api.clients.Company.GetCompanyLicenseInformation(
      editedCompanyId
    ).toPromise();

    if (!companyLicenseInfo) {
      throw new Error('No company license information data received');
    }

    return companyLicenseInfo;
  }
}
